// src/components/Subscription/PremiumBadge.jsx
//
// Tiny presentational tier badge: lock icon + tier label.
// Used by LockedFeature (preview='badge') and anywhere we need to mark a
// paid-only surface inline.
//
import React from 'react';
import { Chip } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useTranslation } from 'react-i18next';

// Map tier → MUI palette color key. ThemeContext defines warning + info.
const TIER_COLOR = {
  standard: 'info',
  premium: 'warning',
  family: 'secondary',
  business: 'primary',
};

const PremiumBadge = ({
  tier = 'premium',
  size = 'small',
  variant = 'filled',
  sx = {},
  ...rest
}) => {
  const { t } = useTranslation();
  const color = TIER_COLOR[tier] || 'warning';
  const label = t(`subscription.locked.${tier}`, tier.toUpperCase());

  return (
    <Chip
      icon={<LockIcon sx={{ fontSize: size === 'small' ? 12 : 14 }} />}
      label={label}
      size={size}
      color={color}
      variant={variant}
      sx={{
        fontWeight: 700,
        letterSpacing: 0.5,
        height: size === 'small' ? 20 : 24,
        '& .MuiChip-label': {
          px: 0.75,
          fontSize: size === 'small' ? '0.65rem' : '0.7rem',
        },
        '& .MuiChip-icon': {
          ml: 0.5,
          mr: -0.25,
        },
        ...sx,
      }}
      {...rest}
    />
  );
};

export default PremiumBadge;
